import LoginType from '../constants/LoginType';
import UserRole from '../constants/UserRole';

export const getUnitCategoryName = (unit, slug, depth) => {
	if (!unit) return '-';

	let categoryBySlug = unit.categories?.find((category) => category.slug === slug);
	let categoryItemByDepth = categoryBySlug?.category_items.find((categoryItem) => categoryItem.depth === depth);
	return categoryItemByDepth?.name ?? '-';
};

export const getCategoryFilterTitle = (categoryFilter, slug, depth) => {
	if (categoryFilter.length === 0) return '';
	let filter = categoryFilter
		.find((category) => category.slug === slug)
		.filters.find((categoryFilter) => categoryFilter.depth === depth);
	return filter.title;
};

export const convertDateToStr = (date) => {
	if (date === null) return null;

	return (
		`${date ? date.getFullYear() : '-'}`.padStart(2, '0') +
		'-' +
		`${date ? date.getMonth() + 1 : '-'}`.padStart(2, '0') +
		'-' +
		`${date ? date.getDate() : '-'}`.padStart(2, '0')
	);
};

export const getUserLoginStr = (user) => {
	if (user.login_type === LoginType.COMMON) {
		return user.user_login;
	}

	if (user.user_login.indexOf('gn') === 0) {
		return user.user_login.substring(2);
	}

	return user.user_login;
};

export const checkRoomAdminRole = (user, unitId) => {
	if (!user) {
		return false;
	}

	// 전체 관리자
	if (user && UserRole.isSystemAdminRole(user.user_role)) {
		return true;
	}

	// 시설 관리자
	if (user && UserRole.isRoomAdminRole(user.user_role)) {
		return true;
	}

	// 예약 항목 관리자
	if (user && UserRole.isTargetRoomUnitAdmin(user.user_role, user.unit_admins, unitId)) {
		return true;
	}

	return false;
};

export const checkProductAdminRole = (user, unitId) => {
	if (!user) {
		return false;
	}

	// 전체 관리자
	if (user && UserRole.isSystemAdminRole(user.user_role)) {
		return true;
	}

	// 시설 관리자
	if (user && UserRole.isProductAdminRole(user.user_role)) {
		return true;
	}

	// 예약 항목 관리자
	if (user && UserRole.isTargetProductUnitAdmin(user.user_role, user.unit_admins, unitId)) {
		return true;
	}

	return false;
};
